export const callsignRegex = /([A-Z]{2,3}[0-9]{3})/;
export const icaoRegex = / ([A-Z]{4}) /;
export const dateTimeRegex = /(\d{6})/;
export const timeRegex = /OBS AT (\d{4})Z/;
export const flightLevelRegex = /FL(\d{3})(?:\/(\d{3}))?/;
